import { Icon } from "components/Icons";
import { NavLink } from "react-router-dom";
import React, { useState } from "react";
import PlaylistModal from "components/PlaylistModal";

export default function Menu({ setShowSidebar }) {
  
  const [showModal, setShowModal] = useState(false);

  const handleGenerateClick = (e) => {
    e.preventDefault(); // Prevent link navigation
    setShowModal(true);
  };

  const menuItems = [
    {
      name: "Home",
      to: "/",
      icon: "home",
      activeIcon: "acthome",
    },
    {
      name: "Best of iChill",
      to: "/BestOfIchill",
      icon: "BestOf",
      activeIcon: "BestOf",
    },
    {
      name: "New Releases & Categories",
      to: "/NewReleases",
      icon: "lib",
      activeIcon: "actcollection",
    },
    {
      name: "Albums",
      to: "/Albums",
      icon: "albumsIcon",
      activeIcon: "albumsIcon",
    },
    {
      name: "Ai playlist generator",
      to: "/collection", // This can stay, but we'll prevent navigation on click
      icon: "mai",
      activeIcon: "actcollection",
      onClick: handleGenerateClick,
    },
  ];
  return (
    <div id="tummenu">
      <nav className="px-2">
        <ul className="flex flex-col">
          {menuItems.map((menuItem) => (
            <li key={menuItem.name}>
              <NavLink
                to={menuItem.to}
                onClick={(e) => {
                  if (menuItem.onClick) {
                    menuItem.onClick(e);
                  }
                  setShowSidebar(false);
                }}
                className="h-12 flex items-center text-sm font-bold text-link hover:text-white px-4 py-2"
              >
                {window.location.pathname === menuItem.to ? (
                  <Icon name={menuItem.activeIcon} />
                ) : (
                  <Icon name={menuItem.icon} />
                )}
                <span className="ml-4">{menuItem.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {showModal && <PlaylistModal onClose={() => setShowModal(false)} />}
    </div>
  );
}
